;(function () {

"use strict";

var FileInputTemplate = require('./templates/file-input.html');

var swap = function (arr, x, y) {
  var b = arr[y];
  arr[y] = arr[x];
  arr[x] = b;
};

var MultipleFilesView = Backbone.View.extend({
  initialize: function () {
    this.$multipleUploader = this.$el.find('.multiple-uploader');
    this.$multipleInput = this.$el.find('input.multiple');
    this.$addRow = this.$el.find('.add-file-row');
    this.$files = this.$el.find('.files');
    this.$textInput = this.$el.find('input[type="text"]');
    this.files = this.$textInput.val() ? this.$textInput.val().split(',') : [];
    this.renderFileInputs();
    this.handle = this.$el.data('handle')
  },
  upload: function (files) {
    var formData = new FormData();

    // Loop through each of the selected files.
    for (var i = 0; i < files.length; i++) {
      var file = files[i];

      // Add the file to the request.
      formData.append(this.handle+'|::|'+i, file, file.name);
    }

    var xhr = new XMLHttpRequest();


    xhr.open('POST', '/detail/upload/'+window.data.type, true);
    xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);

    var self = this;
    ShopifyApp.Bar.loadingOn();
    ShopifyApp.flashNotice('Upload Started');

    xhr.onload = function () {
      if (xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
        if (json.err) {
          ShopifyApp.Modal.alert({
            title: 'An Upload Error Occured',
            message: 'Sorry, Something went wrong. Please try this action again with smaller files or contact jason@thebestagency.com for more help.'
          });
        } else {
          self.update(json);
          ShopifyApp.flashNotice('Upload Completed');
        }

        ShopifyApp.Bar.loadingOff();
      } else {
        alert('An error occurred!');
        ShopifyApp.Bar.loadingOff();
      }
    };
    xhr.send(formData);
  },
  uploadSingle: function (files, idx) {
    var formData = new FormData();

    // Loop through each of the selected files.
    for (var i = 0; i < files.length; i++) {
      var file = files[i];

      // Add the file to the request.
      formData.append(this.handle+'|::|'+i, file, file.name);
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/detail/upload/'+window.data.type, true);
    xhr.setRequestHeader("Authorization", "Bearer " + window.sessionToken);

    var self = this;

    ShopifyApp.Bar.loadingOn();
    ShopifyApp.flashNotice('Upload Started');

    xhr.onload = function () {
      if (xhr.status === 200) {
        var json = JSON.parse(xhr.responseText);
        if (json.err) {
          ShopifyApp.Modal.alert({
            title: 'An Upload Error Occured',
            message: 'Sorry, Something went wrong. Please try this action again with smaller files or contact jason@thebestagency.com for more help.'
          });
        } else {
          ShopifyApp.flashNotice('Upload Completed');
          self.updateSingle(json, idx);
        }
        ShopifyApp.Bar.loadingOff();
      } else {
        alert('An error occurred!');
        ShopifyApp.Bar.loadingOff();
      }
    };
    xhr.send(formData);
  },
  renderFileInputs: function () {
    if (this.files[0]) {
      this.$multipleUploader.hide();
      this.$addRow.show();
    } else {
      this.$multipleUploader.show();
      this.$addRow.hide();
    }

    var $files = this.$files;
    $files.empty();

    var idx = 0;
    var self = this;
    _.each(this.files, function (val, key) {
      $files.append(_.template(FileInputTemplate)({
        val: val,
        idx: idx,
        len: self.files.length }));
      idx++;
    });
  },
  updateValue: function () {
    var paths = [];
    _.each(this.files, function (val, key) {
      if (val !== '') {
        paths.push(val);
      }
    });

    this.fileString = paths.join(',');
    this.$textInput.val(this.fileString);
  },
  updateSingle: function (json, idx) {
    this.files[idx] = json.savedFiles[Object.keys(json.savedFiles)[0]];
    this.renderFileInputs();
    this.updateValue();
  },
  update: function (json) {
    var files = [];
    _.each(json.savedFiles, function (val, key) {
      if (val !== '') {
        files.push(val);
      }
    });
    this.files = files;
    this.renderFileInputs();
    this.updateValue();
  },
  moveUp: function (e) {
    var idx = $(e.currentTarget).closest('.row').index();
    swap(this.files, idx, idx-1);

    this.renderFileInputs();
    this.updateValue();

    return false;
  },
  moveDown: function (e) {
    var idx = $(e.currentTarget).closest('.row').index();
    swap(this.files, idx, idx+1);

    this.renderFileInputs();
    this.updateValue();

    return false;
  },
  updateFile: function (e) {
    console.log('updating file');
    var $this = $(e.currentTarget);
    var files = $this.closest('.row').find('input')[0].files;
    var idx = $this.closest('.row').index();

    if (files.length !== 0) {
      this.uploadSingle(files, idx);
    } else {
      $this.closest('.row').find('input').trigger('click');
    }

    return false;
  },
  removeFile: function (e) {
    var $this = $(e.currentTarget);
    var idx = $this.closest('.row').index();

    this.files.splice(idx, 1);

    this.renderFileInputs();
    this.updateValue();

    return false;
  },
  addFile: function (e) {

    this.files.push('');
    this.renderFileInputs();
    this.updateValue();

    return false;
  },
  onChange: function (e) {
    console.log('file was uploaded');
    var $this = $(e.currentTarget);
    $this.closest('.row').find('.update-file').trigger('click');
  },
  events: {
    'click .upload': function (e) {
      var files = this.$multipleInput[0].files;
      if (files.length !== 0) {
        this.upload(files);
      } else {
        this.$multipleUploader.find('input').trigger('click');
      }

      return false;
    },
    'change .multiple-uploader input': function (e) {
      this.$el.find('.upload').trigger('click');
    },
    'click .update-file': 'updateFile',
    'click .remove-file': 'removeFile',
    'click .add-file': 'addFile',
    'click .move-up': 'moveUp',
    'click .move-down': 'moveDown',
    'change .input.row input[type="file"]': 'onChange',
  }
});

module.exports = MultipleFilesView;

})();